import React, { useRef } from 'react';
import USBCheckboxGroup from '@usb-shield/react-forms-checkbox-group';

function QuestionCheckboxGroup({
    id,
    metadata,
    answers,
    dynamicErrorCount,
    errorMessages,
    updateCallback = () => {},
}) {
    const checkRef = useRef();
    const convertedAnswers = answers.map((thisAnswer) => ({
        label: thisAnswer.label,
        id: thisAnswer.id,
        valid: thisAnswer.id,
        checked: thisAnswer?.checked,
    }));

    const legendText = metadata?.parentQuestion
        ? ''
        : metadata?.question;
    return (
        <div>
            <USBCheckboxGroup
                ref={checkRef}
                inputName={`question-${id}-checkbox-group`}
                legendText={legendText || ''}
                hasIcon={false}
                options={convertedAnswers}
                dynamicErrorCount={dynamicErrorCount}
                statusUpdateCallback={updateCallback}
                errorMessages={errorMessages}
            />
        </div>
    );
}

export default QuestionCheckboxGroup;
